// Motor de cálculo e montagem de HTML da Proposta Comercial / Simulador Embracon.
// Portado 1:1 do Apps Script original (Index.html) — ver funções:
// simRecalcular, simRenderResultado, _gerarHTMLSimulador, atualizarPreview, _gerarPreviewHtmlDados.

export const SEG_ICONS = { 'Automóvel': '🚗', 'Imóvel': '🏠', 'Serviço / Moto': '🏍️', 'Pesados': '🚛' }
export const CARD_COLORS = ['#4a5c2f', '#2980b9', '#8e44ad', '#c0392b', '#e67e22', '#16a085']

export function parseVal(v) {
  if (!v) return 0
  return parseFloat(v.toString().replace('R$', '').replace(/\./g, '').replace(',', '.').trim()) || 0
}

export function fmtBRL(v) {
  if (!v || isNaN(v)) return '—'
  return 'R$ ' + parseFloat(v).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export function fmtSim(v) {
  if (isNaN(v) || !isFinite(v)) return '—'
  return 'R$ ' + v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export function novaCarta() {
  return { segmento: 'Automóvel', credito: '', taxa: '', fundo: '', seguro: '', _seguroChecked: false, mostrarLiquido: true, grupos: [{ qtd: '', valor: '' }], obs: '' }
}

// ================= SIMULADOR — MATEMÁTICA =================

export function simMenorParcelaAuto(p, cat) {
  var total = p.credito + p.credito * (p.taxa + p.fundo + p.antec) / 100
  if (p.dil === 4) return p.credito / p.prazo + (p.taxa + p.fundo) * p.credito / 100 / p.prazo
  return cat === 'pesados' ? total * 0.0075 : total * 0.01
}

export function simContempAutoConv(p, lanceE, lanceR, prima, demais, menorParc) {
  var total = p.credito + p.credito * (p.taxa + p.fundo + p.antec) / 100
  var contemps = []
  var mesesArr = [1, 3, 6, 12]
  mesesArr.forEach(function (m) {
    var redParcela, novoPrazo
    if (p.dil === 4) {
      redParcela = demais
    } else {
      var red = demais - (lanceE + lanceR) / (p.prazo - m)
      redParcela = red < menorParc ? menorParc : red
    }
    novoPrazo = (total - prima - lanceE - lanceR - (m > 1 ? demais * (m - 1) : 0)) / redParcela
    contemps.push({ parcela: redParcela, prazo: novoPrazo })
  })
  return contemps
}

// p: {tipo,credito,prazo,taxa,fundo,antec,dil,lanceRp,lanceRp50,cat}
export function simRecalcular(p) {
  var r = {}
  if (p.tipo === 'autoconv') {
    r.lanceEmb25 = p.dil === 4 ? 0 : p.credito * 0.25
    r.lanceRp = 0
    r.lancePct25 = 0
    r.saldoLiq25 = p.credito - r.lanceEmb25
    r.parcelaPrimeira25 = (p.credito * (p.antec / p.dil)) / 100 + (p.credito / p.prazo + (p.taxa + p.fundo) * p.credito / 100 / p.prazo)
    r.parcelaDemais25 = p.credito / p.prazo + (p.taxa + p.fundo) * p.credito / 100 / p.prazo
    var menorParcela25 = simMenorParcelaAuto(p, 'auto')
    r.contemp25 = simContempAutoConv(p, r.lanceEmb25, r.lanceRp, r.parcelaPrimeira25, r.parcelaDemais25, menorParcela25)

    r.lanceEmb50 = p.credito * 0.25
    r.lancePct50 = p.credito > 0 ? ((r.lanceEmb50 + p.lanceRp50) / p.credito * 100) : 0
    r.saldoLiq50 = p.credito - r.lanceEmb50
    r.parcelaDemais50 = r.parcelaDemais25
    r.parcelaPrimeira50 = r.parcelaPrimeira25
    var totalAC = p.credito + p.credito * (p.taxa + p.fundo + p.antec) / 100
    var lanceRp50ac = p.lanceRp50 || 0
    r.contemp50 = [
      { parcela: menorParcela25, prazo: Math.round((totalAC - r.parcelaPrimeira25 - r.lanceEmb50 - lanceRp50ac) / menorParcela25) },
      { parcela: menorParcela25, prazo: Math.round((totalAC - r.parcelaPrimeira25 - r.lanceEmb50 - lanceRp50ac - r.parcelaDemais25 * 2) / menorParcela25) },
      { parcela: menorParcela25, prazo: Math.round((totalAC - r.parcelaPrimeira25 - r.lanceEmb50 - lanceRp50ac - r.parcelaDemais25 * 5) / menorParcela25) },
      { parcela: menorParcela25, prazo: Math.round((totalAC - r.parcelaPrimeira25 - r.lanceEmb50 - lanceRp50ac - r.parcelaDemais25 * 11) / menorParcela25) }
    ]
    r.menorParcela = menorParcela25
    r.menorParcelaLabel = p.cat === 'pesados' ? 'PESADOS (0,75% categoria)' : 'AUTOS/EQUIP. (1% categoria)'
  } else if (p.tipo === 'automais') {
    var d9 = p.credito * (p.taxa + p.fundo * 0.75) / 100
    var d11 = p.credito * 0.75
    var c14 = (d11 + d9) / p.prazo
    var c13 = (p.credito * (p.antec / p.dil)) / 100 + c14
    var lanceEmb25 = p.dil === 4 ? 0 : p.credito * 0.25
    var saldoLiq25 = p.credito - lanceEmb25
    var lancePct25 = 25
    var contemp25_1 = c14 - (p.lanceRp / (p.prazo - 1))
    var contemp25_3 = c14 - (p.lanceRp / (p.prazo - 3))
    var contemp25_6 = c14 - (p.lanceRp / (p.prazo - 6))
    var contemp25_12 = c14 - (p.lanceRp / (p.prazo - 12))
    var lanceEmb50 = p.credito * 0.25
    var saldoLiq50 = p.credito - lanceEmb50
    var menorParcela = simMenorParcelaAuto(p, 'auto')
    var j9 = p.credito * (p.taxa + p.fundo * 0.75) / 100
    var j11 = p.credito * 0.75
    var i14 = (j11 + j9) / p.prazo
    var totalMais = p.credito + p.credito * (p.taxa + p.fundo + p.antec) / 100
    var lanceRp50val = p.lanceRp50 || 0
    var h20parc = menorParcela, h21parc = menorParcela, h22parc = menorParcela, h23parc = menorParcela
    var i20prazo = Math.round((totalMais - c13 - lanceEmb50 - lanceRp50val) / h20parc)
    var i21prazo = Math.round((totalMais - c13 - lanceEmb50 - lanceRp50val - c14 * 2) / h21parc)
    var i22prazo = Math.round((totalMais - c13 - lanceEmb50 - lanceRp50val - c14 * 5) / h22parc)
    var i23prazo = Math.round((totalMais - c13 - lanceEmb50 - lanceRp50val - c14 * 11) / h23parc)
    var contemp25arr = [
      { parcela: Math.max(contemp25_1, menorParcela), prazo: Math.round((totalMais - (c13 + lanceEmb25 + p.lanceRp)) / Math.max(contemp25_1, menorParcela)) },
      { parcela: Math.max(contemp25_3, menorParcela), prazo: Math.round((totalMais - (c13 + lanceEmb25 + p.lanceRp + c14 * 2)) / Math.max(contemp25_3, menorParcela)) },
      { parcela: Math.max(contemp25_6, menorParcela), prazo: Math.round((totalMais - (c13 + lanceEmb25 + p.lanceRp + c14 * 5)) / Math.max(contemp25_6, menorParcela)) },
      { parcela: Math.max(contemp25_12, menorParcela), prazo: Math.round((totalMais - (c13 + lanceEmb25 + p.lanceRp + c14 * 11)) / Math.max(contemp25_12, menorParcela)) }
    ]
    r = {
      tipo: 'automais',
      lanceEmb25: lanceEmb25, lanceRp: p.lanceRp50, lancePct25: lancePct25, saldoLiq25: saldoLiq25,
      parcelaPrimeira25: c13, parcelaDemais25: c14,
      contemp25: contemp25arr,
      lanceEmb50: lanceEmb50, saldoLiq50: saldoLiq50,
      lancePct50: (lanceEmb50 + (p.lanceRp50 || 0)) / p.credito * 100,
      parcelaPrimeira50: c13, parcelaDemais50: i14,
      contemp50: [
        { parcela: h20parc, prazo: i20prazo },
        { parcela: h21parc, prazo: i21prazo },
        { parcela: h22parc, prazo: i22prazo },
        { parcela: h23parc, prazo: i23prazo }
      ],
      menorParcela: menorParcela,
      menorParcelaLabel: p.cat === 'pesados' ? 'PESADOS' : 'AUTOS/EQUIP.'
    }
  } else if (p.tipo === 'imovconv') {
    var lanceEmb = p.credito * 0.25
    var saldoLiq = p.credito - lanceEmb
    var lancePct = (lanceEmb + p.lanceRp) / p.credito * 100
    var parcelaDemaisImov = p.credito / p.prazo + ((p.taxa + p.fundo) * p.credito / 100 / p.prazo)
    var parcelaPrimeiraImov = (p.credito * (p.antec / p.dil)) / 100 + parcelaDemaisImov
    var totalImov = p.credito + p.credito * (p.taxa + p.fundo + p.antec) / 100
    var menorParc = p.dil === 4 ? parcelaDemaisImov : totalImov * 0.005
    var cImov = function (mesesPagos, lanceE, lanceR, prima, demais, menor) {
      var redParcela = p.dil === 4 ? demais : Math.max(demais - (lanceE + lanceR) / (p.prazo - mesesPagos), menor)
      var novoPrazo = (totalImov - (prima + lanceE + lanceR + (mesesPagos > 1 ? demais * (mesesPagos - 1) : 0))) / redParcela
      return { parcela: redParcela, prazo: novoPrazo }
    }
    var ct1 = cImov(1, lanceEmb, p.lanceRp, parcelaPrimeiraImov, parcelaDemaisImov, menorParc)
    var ct3 = cImov(3, lanceEmb, p.lanceRp, parcelaPrimeiraImov, parcelaDemaisImov, menorParc)
    var ct6 = cImov(6, lanceEmb, p.lanceRp, parcelaPrimeiraImov, parcelaDemaisImov, menorParc)
    var ct12 = cImov(12, lanceEmb, p.lanceRp, parcelaPrimeiraImov, parcelaDemaisImov, menorParc)
    var ct1_50 = cImov(1, lanceEmb, p.lanceRp50, parcelaPrimeiraImov, parcelaDemaisImov, menorParc)
    var ct3_50 = cImov(3, lanceEmb, p.lanceRp50, parcelaPrimeiraImov, parcelaDemaisImov, menorParc)
    var ct6_50 = cImov(6, lanceEmb, p.lanceRp50, parcelaPrimeiraImov, parcelaDemaisImov, menorParc)
    var ct12_50 = cImov(12, lanceEmb, p.lanceRp50, parcelaPrimeiraImov, parcelaDemaisImov, menorParc)
    r = {
      tipo: 'imovconv',
      lanceEmb25: lanceEmb, lanceRp: p.lanceRp, lancePct25: lancePct, saldoLiq25: saldoLiq,
      parcelaPrimeira25: parcelaPrimeiraImov, parcelaDemais25: parcelaDemaisImov,
      contemp25: [ct1, ct3, ct6, ct12],
      lanceEmb50: lanceEmb, lancePct50: lancePct, saldoLiq50: saldoLiq,
      parcelaPrimeira50: parcelaPrimeiraImov, parcelaDemais50: parcelaDemaisImov,
      contemp50: [ct1_50, ct3_50, ct6_50, ct12_50],
      menorParcela: menorParc, menorParcelaLabel: 'IMÓVEL (0,5% categoria)'
    }
  } else if (p.tipo === 'imovmais') {
    var c5 = p.credito, c6 = p.prazo, c7 = p.taxa, c8 = p.fundo
    var d7 = c5 * (c7 + c8) / 100
    var d9b = c5 * 0.745
    var c11 = (c5 * (p.antec / p.dil)) / 100 + (d9b + d7) / c6
    var c12 = (d9b + d7) / c6
    var c13b = c5 * 0.25
    var saldoLiqM = c5 - c13b
    var lancePct25M = 25
    var totalImovM = c5 + c5 * (c7 + c8 + p.antec) / 100
    var menorParcImov = p.dil === 4 ? c12 : totalImovM * 0.005
    var contemp25_1m = c12 - (p.lanceRp / (c6 - 1))
    var contemp25_3m = c12 - (p.lanceRp / (c6 - 3))
    var contemp25_6m = c12 - (p.lanceRp / (c6 - 6))
    var contemp25_12m = c12 - (p.lanceRp / (c6 - 12))
    var i5 = c5, i6 = c6
    var lanceEmb50m = i5 * 0.25
    var lanceRp50m = p.lanceRp
    var lancePct50m = (lanceEmb50m + lanceRp50m) / i5 * 100
    var saldoLiq50m = i5 - lanceEmb50m
    var i9 = p.antec || 2, i10 = p.dil || 12
    var i11 = (i5 * (i9 / i10)) / 100 + c12
    var minParc50 = function (v) { return Math.max(v, menorParcImov) }
    var j18 = (totalImovM - (i11 + lanceEmb50m + lanceRp50m)) / (i6 - 1)
    var j19 = (totalImovM - (i11 + lanceEmb50m + lanceRp50m + c12 * 2)) / (i6 - 3)
    var j20 = (totalImovM - (i11 + lanceEmb50m + lanceRp50m + c12 * 5)) / (i6 - 6)
    var j21 = (totalImovM - (i11 + lanceEmb50m + lanceRp50m + c12 * 11)) / (i6 - 12)
    var h18 = minParc50(j18), h19 = minParc50(j19), h20 = minParc50(j20), h21 = minParc50(j21)
    var np18 = (totalImovM - (i11 + lanceEmb50m + lanceRp50m)) / h18
    var np19 = (totalImovM - (i11 + lanceEmb50m + lanceRp50m + c12 * 2)) / h19
    var np20 = (totalImovM - (i11 + lanceEmb50m + lanceRp50m + c12 * 5)) / h20
    var np21 = (totalImovM - (i11 + lanceEmb50m + lanceRp50m + c12 * 11)) / h21
    r = {
      tipo: 'imovmais',
      lanceEmb25: c13b, lanceRp: p.lanceRp, lancePct25: lancePct25M, saldoLiq25: saldoLiqM,
      parcelaPrimeira25: c11, parcelaDemais25: c12,
      contemp25: [
        { parcela: Math.max(contemp25_1m, menorParcImov), prazo: Math.round((totalImovM - (c11 + c13b + p.lanceRp)) / Math.max(contemp25_1m, menorParcImov)) },
        { parcela: Math.max(contemp25_3m, menorParcImov), prazo: Math.round((totalImovM - (c11 + c13b + p.lanceRp + c12 * 2)) / Math.max(contemp25_3m, menorParcImov)) },
        { parcela: Math.max(contemp25_6m, menorParcImov), prazo: Math.round((totalImovM - (c11 + c13b + p.lanceRp + c12 * 5)) / Math.max(contemp25_6m, menorParcImov)) },
        { parcela: Math.max(contemp25_12m, menorParcImov), prazo: Math.round((totalImovM - (c11 + c13b + p.lanceRp + c12 * 11)) / Math.max(contemp25_12m, menorParcImov)) }
      ],
      lanceEmb50: lanceEmb50m, lancePct50: lancePct50m, saldoLiq50: saldoLiq50m,
      parcelaPrimeira50: i11, parcelaDemais50: c12,
      contemp50: [
        { parcela: h18, prazo: Math.round(np18) },
        { parcela: h19, prazo: Math.round(np19) },
        { parcela: h20, prazo: Math.round(np20) },
        { parcela: h21, prazo: Math.round(np21) }
      ],
      menorParcela: menorParcImov, menorParcelaLabel: 'IMÓVEL (0,5% categoria)'
    }
  }
  return r
}

// ================= SIMULADOR — HTML =================

export function simRenderResultadoHtml(p, r) {
  var contempsLabel = ['1 mês', '3 meses', '6 meses', '12 meses']
  var tipoNome = { autoconv: 'Automóvel — Convencional', automais: 'Automóvel — Mais por Menos', imovconv: 'Imóvel — Convencional', imovmais: 'Imóvel — Mais por Menos' }

  function _bloco25(lanceE, saldo, prima, demais, contemps) {
    var ctRows = contemps.map(function (ct, i) {
      var pv = typeof ct === 'object' ? ct.parcela : ct
      return '<tr style="border-bottom:1px solid #f5f5f5;">' +
        '<td style="padding:7px 10px;color:#666;font-size:12px;">Contemplação ' + contempsLabel[i] + '</td>' +
        '<td style="padding:7px 10px;font-weight:bold;color:#2e3a18;font-size:12px;">' + fmtSim(pv) + '</td>' +
        '<td></td>' +
        '</tr>'
    }).join('')
    return '<div style="background:white;border-radius:12px;padding:18px;margin-bottom:14px;border-top:3px solid #4a5c2f;box-shadow:0 2px 6px rgba(0,0,0,0.06);">' +
      '<div style="font-size:13px;font-weight:900;color:#4a5c2f;text-transform:uppercase;letter-spacing:.05em;margin-bottom:14px;">&#128274; Lance Fixo 25%</div>' +
      '<div style="display:grid;grid-template-columns:repeat(3,1fr);gap:8px;margin-bottom:12px;">' +
      '<div style="background:#f8faf5;border-radius:8px;padding:10px;"><div style="font-size:9px;color:#aaa;text-transform:uppercase;margin-bottom:3px;">Lance Embutido</div><div style="font-size:13px;font-weight:bold;color:#2e3a18;">' + fmtSim(lanceE) + '</div></div>' +
      '<div style="background:#f8faf5;border-radius:8px;padding:10px;"><div style="font-size:9px;color:#aaa;text-transform:uppercase;margin-bottom:3px;">Lance %</div><div style="font-size:13px;font-weight:bold;color:#2e3a18;">25,0%</div></div>' +
      '<div style="background:#f8faf5;border-radius:8px;padding:10px;"><div style="font-size:9px;color:#aaa;text-transform:uppercase;margin-bottom:3px;">Saldo Líquido</div><div style="font-size:13px;font-weight:bold;color:#4a5c2f;">' + fmtSim(saldo) + '</div></div>' +
      '</div>' +
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:12px;">' +
      '<div style="background:#e8f5e9;border-radius:8px;padding:10px;"><div style="font-size:9px;color:#aaa;text-transform:uppercase;margin-bottom:3px;">' + (p.dil > 1 ? '1ª–' + p.dil + 'ª Parcela' : '1ª Parcela') + '</div><div style="font-size:18px;font-weight:900;color:#2e7d32;">' + fmtSim(prima) + '</div></div>' +
      '<div style="background:#f8faf5;border-radius:8px;padding:10px;"><div style="font-size:9px;color:#aaa;text-transform:uppercase;margin-bottom:3px;">Demais Parcelas</div><div style="font-size:18px;font-weight:900;color:#2e3a18;">' + fmtSim(demais) + '</div></div>' +
      '</div>' +
      '<div style="border-top:1px solid #f0f0f0;padding-top:10px;">' +
      '<div style="font-size:10px;color:#aaa;text-transform:uppercase;font-weight:bold;margin-bottom:6px;">Após Contemplação</div>' +
      '<table style="width:100%;border-collapse:collapse;">' + ctRows + '</table>' +
      '</div>' +
      '</div>'
  }

  function _bloco50(lanceE, lanceRp, saldo, prima, demais, contemps) {
    var lanceRpPct = p.credito > 0 ? (lanceRp / p.credito * 100) : 0
    var lanceEPct = p.credito > 0 ? (lanceE / p.credito * 100) : 0
    var lanceTotalPct = lanceEPct + lanceRpPct
    var corTotal = lanceTotalPct >= 50 ? '#1d4ed8' : '#2980b9'
    var ctRows = contemps.map(function (ct, i) {
      var pv = typeof ct === 'object' ? ct.parcela : ct
      var pz = typeof ct === 'object' ? Math.round(ct.prazo) : null
      return '<tr style="border-bottom:1px solid #dbeafe;">' +
        '<td style="padding:7px 10px;color:#666;font-size:12px;">Contemplação ' + contempsLabel[i] + '</td>' +
        '<td style="padding:7px 10px;font-weight:bold;color:#1e40af;font-size:12px;">' + fmtSim(pv) + '</td>' +
        (pz !== null ? '<td style="padding:7px 10px;color:#93c5fd;font-size:12px;">' + pz + 'x</td>' : '<td></td>') +
        '</tr>'
    }).join('')
    return '<div style="background:white;border-radius:12px;padding:18px;margin-bottom:14px;border-top:3px solid #2980b9;box-shadow:0 2px 6px rgba(0,0,0,0.06);">' +
      '<div style="font-size:13px;font-weight:900;color:#2980b9;text-transform:uppercase;letter-spacing:.05em;margin-bottom:14px;">&#128275; Lance Fixo 50% / Livre</div>' +
      '<div style="display:grid;grid-template-columns:1fr 1fr 1fr;gap:8px;margin-bottom:12px;">' +
      '<div style="background:#eff6ff;border-radius:8px;padding:10px;">' +
      '<div style="font-size:9px;color:#93c5fd;text-transform:uppercase;margin-bottom:3px;">Embutido</div>' +
      '<div style="font-size:13px;font-weight:bold;color:#1e40af;">' + fmtSim(lanceE) + '</div>' +
      '<div style="font-size:10px;color:#93c5fd;margin-top:2px;">' + lanceEPct.toFixed(1) + '%</div>' +
      '</div>' +
      '<div style="background:#eff6ff;border-radius:8px;padding:10px;">' +
      '<div style="font-size:9px;color:#93c5fd;text-transform:uppercase;margin-bottom:3px;">Recursos Próprios</div>' +
      '<div style="font-size:13px;font-weight:bold;color:#1e40af;">' + fmtSim(lanceRp) + '</div>' +
      '<div style="font-size:10px;color:#93c5fd;margin-top:2px;">' + lanceRpPct.toFixed(1) + '%</div>' +
      '</div>' +
      '<div style="background:#dbeafe;border-radius:8px;padding:10px;border:2px solid ' + corTotal + ';text-align:center;">' +
      '<div style="font-size:9px;color:' + corTotal + ';text-transform:uppercase;margin-bottom:3px;">Lance Total</div>' +
      '<div style="font-size:22px;font-weight:900;color:' + corTotal + ';">' + lanceTotalPct.toFixed(1) + '%</div>' +
      '</div>' +
      '</div>' +
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:12px;">' +
      '<div style="background:#eff6ff;border-radius:8px;padding:10px;"><div style="font-size:9px;color:#93c5fd;text-transform:uppercase;margin-bottom:3px;">Saldo Líquido</div><div style="font-size:13px;font-weight:bold;color:#1e40af;">' + fmtSim(saldo) + '</div></div>' +
      '<div style="background:#eff6ff;border-radius:8px;padding:10px;"><div style="font-size:9px;color:#93c5fd;text-transform:uppercase;margin-bottom:3px;">Demais Parcelas</div><div style="font-size:18px;font-weight:900;color:#1e40af;">' + fmtSim(demais) + '</div></div>' +
      '</div>' +
      (Math.abs(prima - demais) > 0.01 ?
        '<div style="background:#eff6ff;border-radius:8px;padding:10px;margin-bottom:12px;">' +
        '<div style="font-size:9px;color:#93c5fd;text-transform:uppercase;margin-bottom:3px;">' + (p.dil > 1 ? '1ª–' + p.dil + 'ª Parcela' : '1ª Parcela') + '</div>' +
        '<div style="font-size:18px;font-weight:900;color:#2980b9;">' + fmtSim(prima) + '</div>' +
        '</div>' : '') +
      '<div style="border-top:1px solid #dbeafe;padding-top:10px;">' +
      '<div style="font-size:10px;color:#93c5fd;text-transform:uppercase;font-weight:bold;margin-bottom:6px;">Após Contemplação</div>' +
      '<table style="width:100%;border-collapse:collapse;">' + ctRows + '</table>' +
      '</div>' +
      '</div>'
  }

  var menorDiv = '<div style="background:#fff8e1;border-radius:10px;padding:12px 14px;border-left:4px solid #f39c12;font-size:12px;color:#555;margin-bottom:14px;">' +
    '<strong>Menor parcela pós-contemplação:</strong> ' + r.menorParcelaLabel + ' → ' + fmtSim(r.menorParcela) +
    '</div>'

  return '<div style="font-size:15px;font-weight:bold;color:#4a5c2f;margin-bottom:4px;">' + tipoNome[p.tipo] + '</div>' +
    '<div style="font-size:12px;color:#888;margin-bottom:16px;">Crédito: ' + fmtSim(p.credito) + ' · Prazo: ' + p.prazo + 'x · Taxa: ' + p.taxa + '% · FR: ' + p.fundo + '%</div>' +
    menorDiv +
    _bloco25(r.lanceEmb25, r.saldoLiq25, r.parcelaPrimeira25, r.parcelaDemais25, r.contemp25) +
    _bloco50(r.lanceEmb50 || r.lanceEmb25, p.lanceRp50 || 0, r.saldoLiq50 || r.saldoLiq25, r.parcelaPrimeira50, r.parcelaDemais50, r.contemp50)
}

export function gerarHTMLSimulador(p, r) {
  var tipoNome = { autoconv: 'Automóvel — Convencional', automais: 'Automóvel — Mais por Menos', imovconv: 'Imóvel — Convencional', imovmais: 'Imóvel — Mais por Menos' }
  var fmtV = function (v) { return isNaN(v) || !isFinite(v) ? '—' : 'R$ ' + v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
  var labels = ['1 mês', '3 meses', '6 meses', '12 meses']
  function _ctRows(contemps, cor, mostrarPrazo) {
    return contemps.map(function (ct, i) {
      var pv = typeof ct === 'object' ? ct.parcela : ct
      var pz = typeof ct === 'object' ? Math.round(ct.prazo) : null
      return '<tr style="border-bottom:1px solid #f0f0f0;">' +
        '<td style="padding:4px 8px;font-size:11px;color:#555;">' + labels[i] + '</td>' +
        '<td style="padding:4px 8px;font-weight:bold;color:' + cor + ';font-size:11px;">' + fmtV(pv) + '</td>' +
        (mostrarPrazo && pz ? '<td style="padding:4px 8px;font-size:11px;color:#888;">' + pz + 'x</td>' : '<td></td>') +
        '</tr>'
    }).join('')
  }
  function _blocoHtml(titulo, cor, lanceEmb, lanceRp, lancePct, saldo, prima, demais, contemps, dil, mostrarPrazo) {
    var lanceRpPct = p.credito > 0 ? (lanceRp / p.credito * 100) : 0
    return '<div style="border:1.5px solid ' + cor + ';border-radius:8px;padding:12px;page-break-inside:avoid;">' +
      '<div style="font-size:12px;font-weight:bold;color:' + cor + ';margin-bottom:8px;padding-bottom:5px;border-bottom:1.5px solid ' + cor + ';">' + titulo + '</div>' +
      '<div style="display:grid;grid-template-columns:repeat(auto-fit,minmax(96px,1fr));gap:6px;margin-bottom:8px;">' +
      '<div style="background:#f8f8f8;padding:6px 5px;border-radius:5px;text-align:center;"><div style="font-size:8px;color:#999;text-transform:uppercase;">Lance Emb.</div><div style="font-weight:bold;font-size:11px;color:#333;">' + fmtV(lanceEmb) + '</div><div style="font-size:8px;color:#999;">25%</div></div>' +
      (lanceRp > 0 ? '<div style="background:#f8f8f8;padding:6px 5px;border-radius:5px;text-align:center;"><div style="font-size:8px;color:#999;text-transform:uppercase;">Rec. Próprios</div><div style="font-weight:bold;font-size:11px;color:#333;">' + fmtV(lanceRp) + '</div><div style="font-size:8px;color:#999;">' + lanceRpPct.toFixed(1) + '%</div></div>' : '') +
      '<div style="background:' + cor + '1a;padding:6px 5px;border-radius:5px;text-align:center;border:1.5px solid ' + cor + ';"><div style="font-size:8px;color:' + cor + ';text-transform:uppercase;">Total</div><div style="font-weight:bold;font-size:13px;color:' + cor + ';">' + lancePct.toFixed(1) + '%</div></div>' +
      '<div style="background:#f8f8f8;padding:6px 5px;border-radius:5px;text-align:center;"><div style="font-size:8px;color:#999;text-transform:uppercase;">Saldo Líq.</div><div style="font-weight:bold;font-size:11px;color:#333;">' + fmtV(saldo) + '</div></div>' +
      '<div style="background:#f8f8f8;padding:6px 5px;border-radius:5px;text-align:center;"><div style="font-size:8px;color:#999;text-transform:uppercase;">Men. Parc.</div><div style="font-weight:bold;font-size:11px;color:#333;">' + fmtV(r.menorParcela) + '</div></div>' +
      '</div>' +
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:6px;margin-bottom:8px;">' +
      (Math.abs(prima - demais) > 0.01 ? '<div style="background:#f0fff0;padding:8px;border-radius:5px;text-align:center;border:1px solid #c8e6c9;"><div style="font-size:9px;color:#999;text-transform:uppercase;">' + (dil > 1 ? '1ª–' + dil + 'ª Parcela' : '1ª Parcela') + '</div><div style="font-weight:bold;font-size:14px;color:#2e7d32;">' + fmtV(prima) + '</div></div>' : '<div></div>') +
      '<div style="background:#f5f5f5;padding:8px;border-radius:5px;text-align:center;border:1px solid #e0e0e0;"><div style="font-size:9px;color:#999;text-transform:uppercase;">Demais Parcelas</div><div style="font-weight:bold;font-size:14px;color:#333;">' + fmtV(demais) + '</div></div>' +
      '</div>' +
      '<div style="font-size:9px;font-weight:bold;color:#999;text-transform:uppercase;margin-bottom:4px;letter-spacing:.04em;">Após Contemplação</div>' +
      '<table style="width:100%;border-collapse:collapse;">' +
      '<thead><tr style="background:#f5f5f5;">' +
      '<th style="padding:4px 8px;text-align:left;font-size:10px;color:#666;font-weight:normal;">Cenário</th>' +
      '<th style="padding:4px 8px;text-align:left;font-size:10px;color:#666;font-weight:normal;">Nova Parcela</th>' +
      (mostrarPrazo ? '<th style="padding:4px 8px;text-align:left;font-size:10px;color:#666;font-weight:normal;">Novo Prazo</th>' : '') +
      '</tr></thead>' +
      '<tbody>' + _ctRows(contemps, cor, mostrarPrazo) + '</tbody>' +
      '</table>' +
      '</div>'
  }
  var credStr = p.credito.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  return '<div style="font-family:\'Segoe UI\',Arial,sans-serif;background:white;color:#333;font-size:12px;border:2px solid #4a5c2f;border-radius:12px;padding:16px;margin-top:16px;page-break-inside:avoid;">' +
    '<div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:12px;padding-bottom:10px;border-bottom:2px solid #4a5c2f;">' +
    '<div style="display:flex;align-items:center;gap:10px;">' +
    '<div>' +
    '<div style="font-size:14px;font-weight:bold;color:#4a5c2f;">📊 Simulação Embracon</div>' +
    '<div style="font-size:11px;color:#666;">' + tipoNome[p.tipo] + '</div>' +
    '</div>' +
    '</div>' +
    '<div style="display:flex;gap:8px;flex-wrap:wrap;justify-content:flex-end;">' +
    '<span style="background:#f0f4e8;padding:3px 8px;border-radius:10px;font-size:10px;font-weight:bold;color:#4a5c2f;">Crédito: R$ ' + credStr + '</span>' +
    '<span style="background:#f0f4e8;padding:3px 8px;border-radius:10px;font-size:10px;font-weight:bold;color:#4a5c2f;">Prazo: ' + p.prazo + 'x</span>' +
    '<span style="background:#f0f4e8;padding:3px 8px;border-radius:10px;font-size:10px;font-weight:bold;color:#4a5c2f;">Taxa: ' + p.taxa + '%</span>' +
    '<span style="background:#f0f4e8;padding:3px 8px;border-radius:10px;font-size:10px;font-weight:bold;color:#4a5c2f;">FR: ' + p.fundo + '%</span>' +
    (p.antec > 0 ? '<span style="background:#f0f4e8;padding:3px 8px;border-radius:10px;font-size:10px;font-weight:bold;color:#4a5c2f;">Antec: ' + p.antec + '%</span>' : '') +
    '</div>' +
    '</div>' +
    '<div style="background:#fff8e1;border:1px solid #ffe082;border-radius:6px;padding:6px 10px;margin-bottom:10px;font-size:11px;color:#555;">' +
    '<strong>Menor parcela pós-contemplação:</strong> ' + r.menorParcelaLabel + ' → ' + fmtV(r.menorParcela) +
    '</div>' +
    '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;overflow:hidden;min-width:0;">' +
    _blocoHtml('🔒 Lance Fixo 25%', '#4a5c2f', r.lanceEmb25, 0, 25, r.saldoLiq25, r.parcelaPrimeira25, r.parcelaDemais25, r.contemp25, p.dil, false) +
    _blocoHtml('🔓 Lance Fixo 50% / Livre', '#2980b9', r.lanceEmb50, p.lanceRp50 || 0, r.lancePct50 || 25, r.saldoLiq50 || r.saldoLiq25, r.parcelaPrimeira50, r.parcelaDemais50, r.contemp50, p.dil, true) +
    '</div>' +
    '<div style="margin-top:8px;font-size:9px;color:#aaa;text-align:center;">Simulação meramente ilustrativa. Valores sujeitos a alteração pela administradora.</div>' +
    '</div>'
}

// ================= PROPOSTA — CARTAS =================

// Carta "ao vivo" no formulário (inclui bloco de seguro e "líquido no lance embutido")
export function montarCartaPreviewLive(carta, idx, total) {
  var cred = parseVal(carta.credito)
  var cor = CARD_COLORS[idx % CARD_COLORS.length]
  var gruposValidos = (carta.grupos || []).filter(function (g) { return g.qtd && g.valor })
  var parcelaStr = ''
  if (gruposValidos.length === 1) {
    parcelaStr = fmtBRL(parseVal(gruposValidos[0].valor)) + '/mês &nbsp;·&nbsp; ' + (parseInt(gruposValidos[0].qtd) || 0) + 'x'
  } else if (gruposValidos.length > 1) {
    parcelaStr = gruposValidos.map(function (g, gi) {
      var qtd = parseInt(g.qtd) || 0; var val = parseVal(g.valor)
      return (gi === 0 ? '1ª–' + qtd + 'ª' : 'Dem.') + '&nbsp;' + fmtBRL(val)
    }).join(' <span style="color:#ccc;">|</span> ')
  }
  var totalParc = gruposValidos.reduce(function (s, g) { return s + (parseInt(g.qtd) || 0) }, 0)
  var taxa = carta.taxa ? carta.taxa : ''; var fundo = carta.fundo ? carta.fundo : ''
  var ico = SEG_ICONS[carta.segmento] || '📋'
  return '<div style="position:relative;background:white;border-radius:12px;padding:16px 18px;margin-bottom:10px;box-shadow:0 2px 8px rgba(0,0,0,0.07);">' +
    '<div style="position:absolute;top:0;left:0;right:0;height:3px;background:' + cor + ';border-radius:12px 12px 0 0;"></div>' +
    '<div style="display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:10px;">' +
    '<div style="display:flex;align-items:center;gap:8px;">' +
    '<span style="font-size:18px;">' + ico + '</span>' +
    '<div>' +
    (carta._labelSimulador ? '<div style="font-size:9px;color:' + cor + ';font-weight:900;text-transform:uppercase;letter-spacing:.08em;margin-bottom:1px;">' + carta._labelSimulador + '</div>' : total > 1 ? '<div style="font-size:9px;color:' + cor + ';font-weight:900;text-transform:uppercase;letter-spacing:.08em;margin-bottom:1px;">Opção ' + (idx + 1) + '</div>' : '<div style="font-size:9px;color:' + cor + ';font-weight:900;text-transform:uppercase;letter-spacing:.08em;margin-bottom:1px;">' + carta.segmento + '</div>') +
    '<div style="font-size:22px;font-weight:900;color:#1a2a0f;line-height:1;">' + (cred ? fmtBRL(cred) : '—') + '</div>' +
    (total > 1 ? '<div style="font-size:10px;color:#888;margin-top:1px;">' + carta.segmento + '</div>' : '') +
    '</div>' +
    '</div>' +
    '<div style="display:flex;flex-direction:column;align-items:flex-end;gap:4px;margin-top:2px;">' +
    (taxa ? '<span style="font-size:9px;background:#f0f4e8;color:#4a5c2f;padding:2px 8px;border-radius:20px;font-weight:700;white-space:nowrap;">Taxa ' + taxa + '</span>' : '') +
    (fundo ? '<span style="font-size:9px;background:#fef9e7;color:#b8860b;padding:2px 8px;border-radius:20px;font-weight:700;white-space:nowrap;">FR ' + fundo + '</span>' : '') +
    '</div>' +
    '</div>' +
    '<div style="border-top:1px solid #f0f0f0;margin-bottom:10px;"></div>' +
    '<div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;">' +
    '<div style="background:#f8faf5;border-radius:8px;padding:8px 10px;">' +
    '<div style="font-size:9px;color:#aaa;text-transform:uppercase;letter-spacing:.04em;margin-bottom:2px;">' + (carta.seguro ? 'Parcela sem seguro' : 'Parcela') + '</div>' +
    '<div style="font-size:12px;font-weight:700;color:#2e3a18;">' + (parcelaStr || '—') + '</div>' +
    '</div>' +
    '<div style="background:#f8faf5;border-radius:8px;padding:8px 10px;">' +
    '<div style="font-size:9px;color:#aaa;text-transform:uppercase;letter-spacing:.04em;margin-bottom:2px;">Prazo total</div>' +
    '<div style="font-size:12px;font-weight:700;color:#2e3a18;">' + (totalParc ? totalParc + ' meses' : '—') + '</div>' +
    '</div>' +
    '</div>' +
    (cred && carta.mostrarLiquido !== false ? ('<div style="background:#f8faf5;border-radius:8px;padding:8px 10px;margin-top:8px;">' +
      '<div style="font-size:9px;color:#aaa;text-transform:uppercase;letter-spacing:.04em;margin-bottom:2px;">Valor líquido no lance embutido (25%)</div>' +
      '<div style="font-size:13px;font-weight:700;color:#4a5c2f;">' + fmtBRL(cred * 0.75) + '</div>' +
      '</div>') : '') +
    (carta.seguro ? ('<div style="background:#fff7ed;border-radius:8px;padding:8px 10px;margin-top:8px;">' +
      '<div style="font-size:9px;color:#c2703d;text-transform:uppercase;letter-spacing:.04em;margin-bottom:2px;">Parcela com seguro</div>' +
      '<div style="font-size:13px;font-weight:700;color:#b45309;">' + fmtBRL(parseVal(carta.seguro)) + '</div>' +
      '</div>') : '') +
    ((carta.obs || '').trim() ? ('<div style="background:rgba(74,92,47,0.07);border-radius:8px;padding:8px 10px;margin-top:8px;border-left:3px solid ' + cor + ';">' +
      '<div style="font-size:8px;color:#4a5c2f;font-weight:900;text-transform:uppercase;letter-spacing:.06em;margin-bottom:2px;">Observações</div>' +
      '<div style="font-size:11px;color:#444;line-height:1.5;white-space:pre-line;">' + carta.obs.trim() + '</div>' +
      '</div>') : '') +
    '</div>'
}

// Bloco unificado (2 colunas) — só quando veio do simulador
export function montarBlocoSimulador(cartas, simResultadoAtual) {
  var p = simResultadoAtual.inputs
  var r = simResultadoAtual.result
  var cred = parseVal(cartas[0].credito)
  var taxa = cartas[0].taxa || ''
  var fundo = cartas[0].fundo || ''
  var ico = SEG_ICONS[cartas[0].segmento] || '📋'
  var fmtV = function (v) { return (isNaN(v) || !isFinite(v)) ? '—' : 'R$ ' + v.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }
  var labels = ['1 mês', '3 meses', '6 meses', '12 meses']

  var g25 = cartas[0].grupos.filter(function (g) { return g.qtd && g.valor })
  var parc25Str = g25.length === 1
    ? fmtV(parseVal(g25[0].valor)) + '/mês · ' + (parseInt(g25[0].qtd) || 0) + 'x'
    : g25.map(function (g, gi) { return (gi === 0 ? '1ª–' + g.qtd + 'ª' : 'Dem.') + ' ' + fmtV(parseVal(g.valor)) }).join(' | ')

  var g50 = cartas[1].grupos.filter(function (g) { return g.qtd && g.valor })
  var parc50Str = g50.length === 1
    ? fmtV(parseVal(g50[0].valor)) + '/mês · ' + (parseInt(g50[0].qtd) || 0) + 'x'
    : g50.map(function (g, gi) { return (gi === 0 ? '1ª–' + g.qtd + 'ª' : 'Dem.') + ' ' + fmtV(parseVal(g.valor)) }).join(' | ')

  var lanceRp50 = p.lanceRp50 || 0
  var lancePct50 = (r.lancePct50 || 25)

  function _ctTabela(contemps, cor) {
    if (!contemps || !contemps.length) return ''
    return '<table style="width:100%;border-collapse:collapse;margin-top:6px;">' +
      contemps.map(function (ct, i) {
        var pv = typeof ct === 'object' ? ct.parcela : ct
        var pz = typeof ct === 'object' ? Math.round(ct.prazo) : null
        return '<tr style="border-bottom:1px solid #f5f5f5;">' +
          '<td style="padding:3px 0;font-size:10px;color:#888;">' + labels[i] + '</td>' +
          '<td style="padding:3px 0;font-size:11px;font-weight:700;color:' + cor + ';text-align:right;">' + fmtV(pv) + (pz ? ' <span style="font-weight:400;color:#aaa;font-size:9px;">/ ' + pz + 'x</span>' : '') + '</td>' +
          '</tr>'
      }).join('') +
      '</table>'
  }

  return (
    '<div style="position:relative;background:white;border-radius:14px;overflow:hidden;box-shadow:0 2px 10px rgba(0,0,0,0.09);margin-bottom:10px;">' +
    '<div style="height:4px;background:linear-gradient(90deg,#4a5c2f 50%,#2980b9 50%);"></div>' +
    '<div style="padding:14px 16px 10px;">' +
    '<div style="display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:12px;">' +
    '<div style="display:flex;align-items:center;gap:8px;">' +
    '<span style="font-size:20px;">' + ico + '</span>' +
    '<div>' +
    '<div style="font-size:9px;font-weight:900;color:#666;text-transform:uppercase;letter-spacing:.08em;margin-bottom:2px;">' + cartas[0].segmento + ' — 2 Opções de Lance</div>' +
    '<div style="font-size:24px;font-weight:900;color:#1a2a0f;line-height:1;">' + fmtV(cred) + '</div>' +
    '</div>' +
    '</div>' +
    '<div style="display:flex;flex-direction:column;align-items:flex-end;gap:4px;margin-top:2px;">' +
    (taxa ? '<span style="font-size:9px;background:#f0f4e8;color:#4a5c2f;padding:2px 8px;border-radius:20px;font-weight:700;">Taxa ' + taxa + '</span>' : '') +
    (fundo ? '<span style="font-size:9px;background:#fef9e7;color:#b8860b;padding:2px 8px;border-radius:20px;font-weight:700;">FR ' + fundo + '</span>' : '') +
    '</div>' +
    '</div>' +
    '<div style="background:#f8faf5;border-radius:8px;padding:8px 12px;margin-bottom:12px;display:flex;align-items:center;justify-content:space-between;">' +
    '<span style="font-size:10px;color:#4a5c2f;font-weight:700;">⬇ Menor parcela pós-contemplação</span>' +
    '<span style="font-size:15px;font-weight:900;color:#4a5c2f;">' + fmtV(r.menorParcela) + '</span>' +
    '</div>' +
    '<div style="display:grid;grid-template-columns:1fr 1fr;gap:10px;">' +
    '<div style="border:1.5px solid #4a5c2f;border-radius:10px;overflow:hidden;">' +
    '<div style="background:#4a5c2f;padding:8px 12px;display:flex;align-items:center;gap:6px;">' +
    '<span style="font-size:14px;">🔒</span>' +
    '<div>' +
    '<div style="font-size:11px;font-weight:900;color:white;">Lance Fixo 25%</div>' +
    '<div style="font-size:9px;color:rgba(255,255,255,0.75);">Embutido — sem entrada própria</div>' +
    '</div>' +
    '</div>' +
    '<div style="padding:10px 12px;">' +
    '<div style="margin-bottom:8px;">' +
    '<div style="font-size:9px;color:#aaa;text-transform:uppercase;margin-bottom:2px;">Lance</div>' +
    '<div style="font-size:13px;font-weight:bold;color:#4a5c2f;">' + fmtV(r.lanceEmb25) + ' <span style="font-size:10px;color:#888;">(25%)</span></div>' +
    '</div>' +
    '<div style="margin-bottom:8px;">' +
    '<div style="font-size:9px;color:#aaa;text-transform:uppercase;margin-bottom:2px;">Parcelas antes contemplação</div>' +
    '<div style="font-size:12px;font-weight:700;color:#2e3a18;">' + parc25Str + '</div>' +
    '</div>' +
    '<div style="border-top:1px solid #eee;padding-top:8px;">' +
    '<div style="font-size:9px;color:#aaa;text-transform:uppercase;margin-bottom:2px;">Após contemplação</div>' +
    _ctTabela(r.contemp25, '#4a5c2f') +
    '</div>' +
    '</div>' +
    '</div>' +
    '<div style="border:1.5px solid #2980b9;border-radius:10px;overflow:hidden;">' +
    '<div style="background:#2980b9;padding:8px 12px;display:flex;align-items:center;gap:6px;">' +
    '<span style="font-size:14px;">🔓</span>' +
    '<div>' +
    '<div style="font-size:11px;font-weight:900;color:white;">Lance Fixo 50% / Livre</div>' +
    '<div style="font-size:9px;color:rgba(255,255,255,0.75);">25% embutido' + (lanceRp50 > 0 ? ' + ' + fmtV(lanceRp50) + ' próprios' : ' + recursos próprios') + '</div>' +
    '</div>' +
    '</div>' +
    '<div style="padding:10px 12px;">' +
    '<div style="margin-bottom:8px;">' +
    '<div style="font-size:9px;color:#aaa;text-transform:uppercase;margin-bottom:2px;">Lance Total</div>' +
    '<div style="font-size:13px;font-weight:bold;color:#2980b9;">' + lancePct50.toFixed(1) + '%' +
    (lanceRp50 > 0 ? ' <span style="font-size:10px;color:#888;">(' + fmtV(lanceRp50) + ' próprios)</span>' : '') +
    '</div>' +
    '</div>' +
    '<div style="margin-bottom:8px;">' +
    '<div style="font-size:9px;color:#aaa;text-transform:uppercase;margin-bottom:2px;">Parcelas antes contemplação</div>' +
    '<div style="font-size:12px;font-weight:700;color:#2e3a18;">' + parc50Str + '</div>' +
    '</div>' +
    '<div style="border-top:1px solid #dbeafe;padding-top:8px;">' +
    '<div style="font-size:9px;color:#aaa;text-transform:uppercase;margin-bottom:2px;">Após contemplação</div>' +
    _ctTabela(r.contemp50, '#2980b9') +
    '</div>' +
    '</div>' +
    '</div>' +
    '</div>' +
    '<div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-top:10px;">' +
    '<div style="background:#f8faf5;border-radius:7px;padding:7px 10px;">' +
    '<div style="font-size:9px;color:#aaa;text-transform:uppercase;margin-bottom:1px;">Saldo líquido (25%)</div>' +
    '<div style="font-size:12px;font-weight:700;color:#4a5c2f;">' + fmtV(r.saldoLiq25) + '</div>' +
    '</div>' +
    '<div style="background:#eff6ff;border-radius:7px;padding:7px 10px;">' +
    '<div style="font-size:9px;color:#93c5fd;text-transform:uppercase;margin-bottom:1px;">Saldo líquido (50%)</div>' +
    '<div style="font-size:12px;font-weight:700;color:#2980b9;">' + fmtV(r.saldoLiq50 || r.saldoLiq25) + '</div>' +
    '</div>' +
    '</div>' +
    '</div>' +
    '</div>'
  )
}

function _formasContemplacaoHtml() {
  function _ico(emoji, label) {
    return '<div style="display:flex;flex-direction:column;align-items:center;gap:6px;flex:1;">' +
      '<div style="width:52px;height:52px;border-radius:50%;border:2px solid #4a5c2f;display:flex;align-items:center;justify-content:center;font-size:22px;">' + emoji + '</div>' +
      '<div style="font-size:9px;font-weight:900;color:#4a5c2f;text-align:center;text-transform:uppercase;letter-spacing:0.5px;line-height:1.3;">' + label + '</div>' +
      '</div>'
  }
  return '<div style="padding:0 26px 16px;">' +
    '<div style="background:white;border-radius:10px;padding:14px 16px;box-shadow:0 1px 4px rgba(0,0,0,0.06);">' +
    '<div style="font-size:11px;font-weight:900;color:#2e3a18;margin-bottom:14px;text-transform:uppercase;letter-spacing:.04em;">Formas de contemplação</div>' +
    '<div style="display:flex;gap:10px;justify-content:space-around;">' +
    _ico('🏆', 'Sorteio') + _ico('🔒', 'Lance<br>Fixo 25%') + _ico('🤝', 'Lance<br>Fixo 50%') + _ico('🆓', 'Lance<br>Livre') +
    '</div>' +
    '<div style="margin-top:10px;font-size:9px;color:#aaa;text-align:center;line-height:1.5;">*Os lances fixos podem utilizar até 25% do valor da cota, sem descapitalizar na contemplação.</div>' +
    '</div>' +
    '</div>'
}

// Preview "ao vivo" (formulário da Proposta) — equivalente a atualizarPreview()
export function montarPreviewLiveHtml(ctx) {
  var nome = ctx.nome || 'Cliente'
  var adm = ctx.adm || ''
  var obs = (ctx.obs || '').trim()
  var nomeEmpresa = ctx.nomeEmpresa || 'ConGestor'
  var dataHoje = new Date().toLocaleDateString('pt-BR')
  var vendedorNome = ctx.vendedorNome || 'Consultor'

  var mostrarBeneficios = !!(ctx.beneficiosConfig && ctx.beneficiosConfig.visivel && ctx.beneficiosConfig.texto)
  var beneficiosHtml = ''
  if (mostrarBeneficios) {
    var linhasBen = ctx.beneficiosConfig.texto.split('\n').filter(function (l) { return l.trim() })
    beneficiosHtml = linhasBen.map(function (l) { return '• ' + l.trim() }).join('<br>')
  }

  var cartasValidas = ctx.cartas.filter(function (c) { return c.credito || c.grupos.some(function (g) { return g.qtd && g.valor }) })
  if (!cartasValidas.length) cartasValidas = ctx.cartas

  var obsPorCarta = ctx.modoObs === 'carta'
  var veiuDoSimulador = !obsPorCarta && ctx.simResultadoAtual && cartasValidas.length === 2 && cartasValidas[0]._labelSimulador && cartasValidas[1]._labelSimulador

  var cartasHtml = veiuDoSimulador
    ? montarBlocoSimulador(cartasValidas, ctx.simResultadoAtual)
    : cartasValidas.map(function (c, i) { return montarCartaPreviewLive(c, i, cartasValidas.length) }).join('')

  return '<div style="background:#f5f0e8;font-family:\'Segoe UI\',Arial,sans-serif;position:relative;min-height:600px;">' +
    '<div style="position:absolute;top:0;right:0;width:110px;height:110px;overflow:hidden;pointer-events:none;z-index:0;">' +
    '<div style="position:absolute;top:-15px;right:-15px;width:100px;height:100px;background:#4a5c2f;transform:rotate(15deg);opacity:0.9;border-radius:6px;"></div>' +
    '<div style="position:absolute;top:8px;right:8px;width:60px;height:60px;background:#6b8040;transform:rotate(10deg);opacity:0.6;border-radius:4px;"></div>' +
    '</div>' +
    '<div style="position:absolute;bottom:0;left:0;width:80px;height:80px;overflow:hidden;pointer-events:none;z-index:0;">' +
    '<div style="position:absolute;bottom:-15px;left:-15px;width:80px;height:80px;background:#4a5c2f;transform:rotate(-15deg);opacity:0.9;border-radius:6px;"></div>' +
    '</div>' +
    '<div style="position:relative;z-index:1;">' +
    '<div style="padding:20px 26px 10px;display:flex;align-items:center;justify-content:space-between;">' +
    '<div style="display:flex;align-items:center;gap:10px;">' +
    '<div style="font-size:14px;font-weight:900;color:#4a5c2f;letter-spacing:1px;">' + nomeEmpresa.toUpperCase() + '</div>' +
    '</div>' +
    '<div style="text-align:right;font-size:10px;line-height:1.7;background:rgba(245,240,232,0.85);padding:4px 8px;border-radius:6px;">' +
    '<div style="font-weight:700;color:#2e3a18;">' + vendedorNome + '</div>' +
    '<div style="color:#666;">' + dataHoje + '</div>' +
    '</div>' +
    '</div>' +
    '<div style="padding:6px 26px 4px;">' +
    '<div style="font-size:40px;font-weight:900;color:#2e3a18;line-height:1;letter-spacing:-2px;text-transform:uppercase;">PROPOSTA<br>IDEAL</div>' +
    '</div>' +
    '<div style="padding:6px 26px 14px;display:flex;align-items:baseline;gap:10px;flex-wrap:wrap;">' +
    '<div style="font-size:17px;font-weight:900;color:#4a5c2f;text-transform:uppercase;letter-spacing:1px;">' + nome + '</div>' +
    (adm ? '<div style="font-size:11px;color:#888;font-weight:600;text-transform:uppercase;">' + adm + '</div>' : '') +
    '</div>' +
    '<div style="padding:0 26px 14px;">' + cartasHtml + '</div>' +
    (mostrarBeneficios && beneficiosHtml ?
      '<div style="padding:2px 26px 14px;">' +
      '<div style="background:white;border-radius:10px;padding:14px 16px;box-shadow:0 1px 4px rgba(0,0,0,0.06);">' +
      '<div style="font-size:11px;font-weight:900;color:#2e3a18;margin-bottom:8px;text-transform:uppercase;letter-spacing:.04em;">Benefícios do grupo</div>' +
      '<div style="font-size:11px;color:#444;line-height:2.0;">' + beneficiosHtml + '</div>' +
      '</div>' +
      '</div>' : '') +
    (obs && !obsPorCarta ?
      '<div style="padding:0 26px 14px;">' +
      '<div style="background:rgba(74,92,47,0.07);border-radius:10px;padding:12px 14px;border-left:3px solid #4a5c2f;">' +
      '<div style="font-size:9px;color:#4a5c2f;font-weight:900;text-transform:uppercase;letter-spacing:.06em;margin-bottom:4px;">Observações</div>' +
      '<div style="font-size:11px;color:#444;line-height:1.7;white-space:pre-line;">' + obs + '</div>' +
      '</div>' +
      '</div>' : '') +
    _formasContemplacaoHtml() +
    (ctx.simHtmlAtual && ctx.simVisivelNaProposta !== false ?
      '<div style="padding:0 26px 14px;">' +
      '<div style="font-size:9px;color:#aaa;text-transform:uppercase;letter-spacing:1px;margin-bottom:8px;padding-bottom:6px;border-bottom:1px solid #eee;">Detalhamento da Simulação</div>' +
      '<div style="overflow:hidden;width:100%;">' + ctx.simHtmlAtual + '</div>' +
      '</div>'
      : '') +
    '<div style="padding:8px 26px 14px;display:flex;justify-content:space-between;border-top:1px solid rgba(0,0,0,0.08);margin:0 26px;">' +
    '<div style="font-size:9px;color:#aaa;">Sujeito à aprovação da administradora</div>' +
    '<div style="font-size:9px;font-weight:700;color:#4a5c2f;">' + nomeEmpresa + '</div>' +
    '</div>' +
    '</div></div>'
}

// Preview de proposta já salva (histórico) — equivalente a _gerarPreviewHtmlDados()
export function montarPreviewSalvaHtml(d, beneficiosConfig, vendedorFallback, nomeEmpresa) {
  if (!d) return '<p style="color:#aaa;">Sem dados.</p>'
  var cartas = d.cartas || []
  if (!cartas.length) return '<p style="color:#aaa;">Sem cartas salvas.</p>'
  nomeEmpresa = nomeEmpresa || 'ConGestor'

  function _ico(emoji, label) {
    return '<div style="display:flex;flex-direction:column;align-items:center;gap:6px;flex:1;">' +
      '<div style="width:48px;height:48px;border-radius:50%;border:2px solid #4a5c2f;display:flex;align-items:center;justify-content:center;font-size:20px;">' + emoji + '</div>' +
      '<div style="font-size:9px;font-weight:900;color:#4a5c2f;text-align:center;text-transform:uppercase;letter-spacing:0.5px;line-height:1.3;">' + label + '</div>' +
      '</div>'
  }
  function _fmtV(v) {
    var n = parseFloat((v || '').toString().replace(/\./g, '').replace(',', '.')) || 0
    return n ? 'R$ ' + n.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : '—'
  }

  var cartasHtml = cartas.map(function (carta, idx) {
    var cred = parseFloat((carta.credito || '').toString().replace(/\./g, '').replace(',', '.')) || 0
    var cor = CARD_COLORS[idx % CARD_COLORS.length]
    var ico = SEG_ICONS[carta.segmento] || '📋'
    var gruposValidos = (carta.grupos || []).filter(function (g) { return g.qtd && g.valor })
    var parcelaStr = ''
    if (gruposValidos.length === 1) {
      parcelaStr = _fmtV(gruposValidos[0].valor) + '/mês &nbsp;·&nbsp; ' + (parseInt(gruposValidos[0].qtd) || 0) + 'x'
    } else if (gruposValidos.length > 1) {
      parcelaStr = gruposValidos.map(function (g, gi) {
        return (gi === 0 ? '1ª–' + g.qtd + 'ª' : ' Dem.') + '&nbsp;' + _fmtV(g.valor)
      }).join(' <span style="color:#ccc;">|</span> ')
    }
    var totalParc = gruposValidos.reduce(function (s, g) { return s + (parseInt(g.qtd) || 0) }, 0)
    return '<div style="position:relative;background:white;border-radius:12px;padding:16px 18px;margin-bottom:10px;box-shadow:0 2px 8px rgba(0,0,0,0.07);">' +
      '<div style="position:absolute;top:0;left:0;right:0;height:3px;background:' + cor + ';border-radius:12px 12px 0 0;"></div>' +
      '<div style="display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:10px;">' +
      '<div style="display:flex;align-items:center;gap:8px;">' +
      '<span style="font-size:18px;">' + ico + '</span>' +
      '<div>' +
      (cartas.length > 1 ? '<div style="font-size:9px;color:' + cor + ';font-weight:900;text-transform:uppercase;letter-spacing:.08em;margin-bottom:1px;">Opção ' + (idx + 1) + '</div>' : '<div style="font-size:9px;color:' + cor + ';font-weight:900;text-transform:uppercase;letter-spacing:.08em;margin-bottom:1px;">' + carta.segmento + '</div>') +
      '<div style="font-size:22px;font-weight:900;color:#1a2a0f;line-height:1;">' + (cred ? 'R$ ' + cred.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : '—') + '</div>' +
      (cartas.length > 1 ? '<div style="font-size:10px;color:#888;margin-top:1px;">' + carta.segmento + '</div>' : '') +
      '</div>' +
      '</div>' +
      '<div style="display:flex;flex-direction:column;align-items:flex-end;gap:4px;margin-top:2px;">' +
      (carta.taxa ? '<span style="font-size:9px;background:#f0f4e8;color:#4a5c2f;padding:2px 8px;border-radius:20px;font-weight:700;">Taxa ' + carta.taxa + '</span>' : '') +
      (carta.fundo ? '<span style="font-size:9px;background:#fef9e7;color:#b8860b;padding:2px 8px;border-radius:20px;font-weight:700;">FR ' + carta.fundo + '</span>' : '') +
      '</div>' +
      '</div>' +
      '<div style="border-top:1px solid #f0f0f0;margin-bottom:10px;"></div>' +
      '<div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;">' +
      '<div style="background:#f8faf5;border-radius:8px;padding:8px 10px;">' +
      '<div style="font-size:9px;color:#aaa;text-transform:uppercase;letter-spacing:.04em;margin-bottom:2px;">Parcela</div>' +
      '<div style="font-size:12px;font-weight:700;color:#2e3a18;">' + (parcelaStr || '—') + '</div>' +
      '</div>' +
      '<div style="background:#f8faf5;border-radius:8px;padding:8px 10px;">' +
      '<div style="font-size:9px;color:#aaa;text-transform:uppercase;letter-spacing:.04em;margin-bottom:2px;">Prazo total</div>' +
      '<div style="font-size:12px;font-weight:700;color:#2e3a18;">' + (totalParc ? totalParc + ' meses' : '—') + '</div>' +
      '</div>' +
      ((carta.obs || '').trim() && (d.modoObs === 'carta') ? ('<div style="background:rgba(74,92,47,0.07);border-radius:8px;padding:8px 10px;margin-top:8px;border-left:3px solid ' + cor + ';">' +
        '<div style="font-size:8px;color:#4a5c2f;font-weight:900;text-transform:uppercase;letter-spacing:.06em;margin-bottom:2px;">Observações</div>' +
        '<div style="font-size:11px;color:#444;line-height:1.5;white-space:pre-line;">' + carta.obs.trim() + '</div>' +
        '</div>') : '') +
      '</div>'
  }).join('')

  var beneficiosHtml = ''
  if (beneficiosConfig && beneficiosConfig.visivel && beneficiosConfig.texto) {
    var linhas = beneficiosConfig.texto.split('\n').filter(function (l) { return l.trim() })
    beneficiosHtml = linhas.map(function (l) { return '• ' + l.trim() }).join('<br>')
  }

  var nome = d.nomeCliente || d.cliente || '—'
  var adm = d.adm || ''
  var obs = d.obs || ''
  var vendedor = d.vendedor || vendedorFallback || 'Consultor'
  var dataExib = d.dataCriacao || ''
  if (dataExib.indexOf('GMT') > -1 || dataExib.indexOf('Apr') > -1) {
    var dt = new Date(dataExib); if (!isNaN(dt.getTime())) dataExib = dt.toLocaleDateString('pt-BR')
  } else if (dataExib.indexOf('/') > -1) {
    dataExib = dataExib.substring(0, 10)
  }

  return '<div style="background:#f5f0e8;font-family:\'Segoe UI\',Arial,sans-serif;border-radius:12px;overflow:hidden;">' +
    '<div style="position:relative;min-height:500px;">' +
    '<div style="position:absolute;top:0;right:0;width:90px;height:90px;overflow:hidden;pointer-events:none;z-index:0;">' +
    '<div style="position:absolute;top:-12px;right:-12px;width:80px;height:80px;background:#4a5c2f;transform:rotate(15deg);opacity:0.9;border-radius:5px;"></div>' +
    '<div style="position:absolute;top:6px;right:6px;width:48px;height:48px;background:#6b8040;transform:rotate(10deg);opacity:0.6;border-radius:4px;"></div>' +
    '</div>' +
    '<div style="position:absolute;bottom:0;left:0;width:64px;height:64px;overflow:hidden;pointer-events:none;z-index:0;">' +
    '<div style="position:absolute;bottom:-12px;left:-12px;width:64px;height:64px;background:#4a5c2f;transform:rotate(-15deg);opacity:0.9;border-radius:5px;"></div>' +
    '</div>' +
    '<div style="position:relative;z-index:1;">' +
    '<div style="padding:18px 22px 10px;display:flex;align-items:center;justify-content:space-between;">' +
    '<div style="display:flex;align-items:center;gap:8px;">' +
    '<div style="font-size:13px;font-weight:900;color:#4a5c2f;letter-spacing:1px;">' + nomeEmpresa.toUpperCase() + '</div>' +
    '</div>' +
    '<div style="text-align:right;font-size:10px;line-height:1.7;background:rgba(245,240,232,0.85);padding:3px 8px;border-radius:6px;">' +
    '<div style="font-weight:700;color:#2e3a18;">' + vendedor + '</div>' +
    '<div style="color:#666;">' + dataExib + '</div>' +
    '</div>' +
    '</div>' +
    '<div style="padding:6px 22px 4px;">' +
    '<div style="font-size:36px;font-weight:900;color:#2e3a18;line-height:1;letter-spacing:-1.5px;text-transform:uppercase;">PROPOSTA<br>IDEAL</div>' +
    '</div>' +
    '<div style="padding:6px 22px 12px;display:flex;align-items:baseline;gap:10px;flex-wrap:wrap;">' +
    '<div style="font-size:16px;font-weight:900;color:#4a5c2f;text-transform:uppercase;letter-spacing:1px;">' + nome + '</div>' +
    (adm ? '<div style="font-size:11px;color:#888;font-weight:600;text-transform:uppercase;">' + adm + '</div>' : '') +
    '</div>' +
    '<div style="padding:0 22px 12px;">' + cartasHtml + '</div>' +
    (beneficiosHtml ? '<div style="padding:0 22px 12px;"><div style="background:white;border-radius:10px;padding:12px 14px;box-shadow:0 1px 4px rgba(0,0,0,0.06);"><div style="font-size:10px;font-weight:900;color:#2e3a18;margin-bottom:6px;text-transform:uppercase;letter-spacing:.04em;">Benefícios do grupo</div><div style="font-size:11px;color:#444;line-height:2.0;">' + beneficiosHtml + '</div></div></div>' : '') +
    (obs && d.modoObs !== 'carta' ? '<div style="padding:0 22px 12px;"><div style="background:rgba(74,92,47,0.07);border-radius:10px;padding:10px 14px;border-left:3px solid #4a5c2f;"><div style="font-size:9px;color:#4a5c2f;font-weight:900;text-transform:uppercase;letter-spacing:.06em;margin-bottom:4px;">Observações</div><div style="font-size:11px;color:#444;line-height:1.7;white-space:pre-line;">' + obs + '</div></div></div>' : '') +
    '<div style="padding:0 22px 14px;"><div style="background:white;border-radius:10px;padding:12px 14px;box-shadow:0 1px 4px rgba(0,0,0,0.06);">' +
    '<div style="font-size:10px;font-weight:900;color:#2e3a18;margin-bottom:12px;text-transform:uppercase;letter-spacing:.04em;">Formas de contemplação</div>' +
    '<div style="display:flex;gap:8px;justify-content:space-around;">' +
    _ico('🏆', 'Sorteio') + _ico('🔒', 'Lance<br>Fixo 25%') + _ico('🤝', 'Lance<br>Fixo 50%') + _ico('🆓', 'Lance<br>Livre') +
    '</div>' +
    '</div></div>' +
    '<div style="padding:8px 22px 12px;display:flex;justify-content:space-between;border-top:1px solid rgba(0,0,0,0.08);margin:0 22px;">' +
    '<div style="font-size:9px;color:#aaa;">Sujeito à aprovação da administradora</div>' +
    '<div style="font-size:9px;font-weight:700;color:#4a5c2f;">' + nomeEmpresa + '</div>' +
    '</div>' +
    '</div></div></div>'
}

// ================= PONTE ENTRE PÁGINAS (edição a partir do histórico) =================
let _pendingEditProposta = null
export function setPendingEditProposta(p) { _pendingEditProposta = p }
export function takePendingEditProposta() { var p = _pendingEditProposta; _pendingEditProposta = null; return p }
